import { cn } from '@/utils/style'

interface ProgressProps {
  value: number
  secondValue?: number
  color?: string
  className?: string
}

export function Progress({ value, secondValue, color, className }: ProgressProps) {
  return (
    <div
      className={cn(
        'w-full h-1.5 rounded-full bg-panel-gray-200 overflow-hidden relative',
        className,
      )}
    >
      <div
        className={cn('absolute h-full bg-btn-secondary rounded-full')}
        style={{ width: `${(secondValue ?? 0) * 100}%` }}
      ></div>
      <div
        className={cn('absolute h-full rounded-full', color ?? 'bg-btn-tertiary')}
        style={{ width: `${value * 100}%` }}
      ></div>
    </div>
  )
}
